import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import style from './Loading.module.scss.js';

var Loading = function Loading(props) {
  var className = props.className,
    inlineStyle = props.inlineStyle;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx(style.PicoLoaderContainer_modal, className)
  }, inlineStyle && {
    style: inlineStyle
  }), /*#__PURE__*/React.createElement("div", {
    className: style.PicoLoader_modal
  }));
};
Loading.defaultProps = {
  inlineStyle: {}
};
Loading.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  inlineStyle: PropTypes.shape({
    top: PropTypes.string
  })
};

export { Loading as default };
//# sourceMappingURL=index.js.map
